<template>
  <div class="application_form_box">
    <template v-if="isShowBtn">
      <el-form :model="query" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="16">
            <el-form-item label="赛事名称" prop="raceName">
              <el-select
                :popper-append-to-body="false"
                style="width:592px"
                v-model="query.raceName"
                placeholder="请选择赛事"
                @change="selectMatch"
              >
                <el-option
                  v-for="(item,index) in matchList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="query" ref="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="校名">
              <el-input
                disabled
                v-model="query.schoolName"
                style="width:200px"
                placeholder="请输入学校名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="组别" prop="groupId">
              <el-select
                :disabled="isUpdate"
                :popper-append-to-body="false"
                style="width:200px"
                @change="selectGroup"
                v-model="query.groupId"
              >
                <el-option
                  v-for="(item,index) in signGroup"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="领队" prop="leaderName">
              <el-input
                v-model="query.leaderName"
                :disabled="isUpdate"
                style="width:200px"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机" prop="leaderPhone">
              <el-input
                v-model="query.leaderPhone"
                :disabled="isUpdate"
                style="width:200px"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮箱" prop="leaderEmail">
              <el-input
                v-model="query.leaderEmail"
                :disabled="isUpdate"
                style="width:200px"
                placeholder="非必填项"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- prop="headCoachId" -->
            <el-form-item label="主教练">
              <el-select
                clearable
                :disabled="isUpdate"
                :popper-append-to-body="false"
                style="width:200px"
                v-model="query.headCoachId"
                @change="selectCoach"
                placeholder="请选择主教练"
              >
                <el-option
                  v-for="(item,index) in coachList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机">
              <el-input
                disabled
                v-model="query.headCoachPhone"
                style="width:200px"
                placeholder="自动匹配"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮箱" prop="headCoachEmail">
              <el-input
                :disabled="isUpdate"
                v-model="query.headCoachEmail"
                style="width:200px"
                placeholder="非必填项"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- prop="coachIds" -->
            <el-form-item label="教练员">
              <el-select
                :disabled="isUpdate"
                :popper-append-to-body="false"
                style="width:200px"
                v-model="query.coachIds"
                multiple
                placeholder="请选择教练员"
              >
                <el-option
                  v-for="(item,index) in otherCoachList"
                  :key="index"
                  :disabled="item.disabled"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- prop="workerNames" -->
            <el-form-item label="工作人员">
              <el-input
                style="width:200px"
                :disabled="isUpdate"
                v-model="query.workerNames"
                placeholder="请输入工作人员姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="住宿">
              <el-row>
                <el-col :span="8.5">
                  <span>男</span>
                  <el-input
                    onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
                    v-model="query.stayMan"
                    style="width:60px;margin:0 8px"
                  ></el-input>
                  <span>，</span>
                </el-col>
                <el-col :span="12">
                  <span style="margin-right:8px">女</span>
                  <el-input
                    onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
                    v-model="query.stayWoman"
                    style="width:60px"
                  ></el-input>
                  <span>（人）</span>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table style="width:100%;margin-top:40px" border :data="tableData">
        <el-table-column label="序号" align="center" type="index" width="80"></el-table-column>
        <el-table-column label="姓名" :min-width="query.groupId?150:200" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'name','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectAthlete($event,$index,'name')"
                style="height:30px"
                v-if="editable[$index].name"
                v-model="row.name"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'name')"
                class="editRemarkInput"
              >
                <el-option
                  :disabled="item.disabled"
                  v-for="item in athleteList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
              <span v-else>{{row.name}}</span>
            </div>
            <span v-else>{{row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="性别" min-width="100" align="center" prop="genderText"></el-table-column>
        <el-table-column label="学号" min-width="100" align="center" prop="studentNumber"></el-table-column>
        <el-table-column label="入学时间" min-width="100" align="center" prop="startSchoolDateText"></el-table-column>
        <el-table-column label="注册号码" min-width="100" align="center" prop="registerNumber"></el-table-column>
        <el-table-column label="电话号码" min-width="120" align="center" prop="phone"></el-table-column>
        <el-table-column label="团体" width="110" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'smallBallGroup','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].smallBallGroup"
                v-model="row.smallBallGroup"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'smallBallGroup')"
                class="editRemarkInput"
              >
                <el-option value="是" label="是"></el-option>
                <el-option value="否" label="否"></el-option>
              </el-select>
              <span v-else>{{row.smallBallGroup}}</span>
            </div>
            <span v-else>{{row.smallBallGroup}}</span>
          </template>
        </el-table-column>
        <el-table-column label="男单" width="110" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="(publishState === 0 || publishState === 2) && row.isSingles !== 'smallBallSingles0'"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'smallBallSingles1','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].smallBallSingles1"
                v-model="row.smallBallSingles1"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'smallBallSingles1')"
                class="editRemarkInput"
              >
                <el-option value="1" label="1"></el-option>
                <el-option value="2" label="2"></el-option>
              </el-select>
              <span v-else>{{row.smallBallSingles1}}</span>
            </div>
            <span v-else>{{row.smallBallSingles1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="女单" width="110" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="(publishState === 0 || publishState === 2) && (row.isSingles !== 'smallBallSingles1')"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'smallBallSingles0','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].smallBallSingles0"
                v-model="row.smallBallSingles0"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'smallBallSingles0')"
                class="editRemarkInput"
              >
                <el-option value="1" label="1"></el-option>
                <el-option value="2" label="2"></el-option>
              </el-select>
              <span v-else>{{row.smallBallSingles0}}</span>
            </div>
            <span v-else>{{row.smallBallSingles0}}</span>
          </template>
        </el-table-column>
        <el-table-column label="男双" width="110" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="(publishState === 0 || publishState === 2) && row.isDoubles !== 'smallBallDoubles0'"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'smallBallDoubles1','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].smallBallDoubles1"
                v-model="row.smallBallDoubles1"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'smallBallDoubles1')"
                class="editRemarkInput"
              >
                <el-option value="双1" label="双1"></el-option>
                <el-option value="双2" label="双2"></el-option>
              </el-select>
              <span v-else>{{row.smallBallDoubles1}}</span>
            </div>
            <span v-else>{{row.smallBallDoubles1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="女双" width="110" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="(publishState === 0 || publishState === 2) && row.isDoubles !== 'smallBallDoubles1'"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'smallBallDoubles0','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].smallBallDoubles0"
                v-model="row.smallBallDoubles0"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'smallBallDoubles0')"
                class="editRemarkInput"
              >
                <el-option value="双1" label="双1"></el-option>
                <el-option value="双2" label="双2"></el-option>
              </el-select>
              <span v-else>{{row.smallBallDoubles0}}</span>
            </div>
            <span v-else>{{row.smallBallDoubles0}}</span>
          </template>
        </el-table-column>
        <el-table-column label="混双" width="110" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'smallBallMixed','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].smallBallMixed"
                v-model="row.smallBallMixed"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'smallBallMixed')"
                class="editRemarkInput"
              >
                <el-option value="混1" label="混1"></el-option>
                <el-option value="混2" label="混2"></el-option>
                <el-option value="混3" label="混3"></el-option>
              </el-select>
              <span v-else>{{row.smallBallMixed}}</span>
            </div>
            <span v-else>{{row.smallBallMixed}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="备注" min-width="100" align="center" prop="remarks">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'remarks','editRemarkInput')}}"
            >
              <el-input
                @keyup.native="$event=>handleKeyUp($event,$index,'remarks','editRemarkInput')"
                maxlength="10"
                v-if="editable[$index].remarks"
                v-model.trim="row.remarks"
                size="mini"
                @blur="$event=>handleBlur($event,$index,'remarks')"
                class="editRemarkInput"
              ></el-input>
              <span v-else>{{row.remarks}}</span>
            </div>
            <span v-else>{{row.remarks}}</span>
          </template>
        </el-table-column>-->
      </el-table>
      <footer v-if="publishState === 0 || publishState === 2">
        <el-button :loading="loadingData.submitLoading" class="btns" @click="submits('submit')">确认提交</el-button>
        <el-button
          :loading="loadingData.saveLoading"
          class="btns"
          @click="submits('save')"
          style="margin:0 20px;"
        >保存草稿</el-button>
        <el-button class="btns" @click="clearData">清空重置</el-button>
      </footer>
      <footer v-else>
        <span style="font-size:22px">审核状态：</span>
        <span
          :style="{color:publishState === 1?'#1E63B0':'#1CC28C'}"
          style="font-size:18px"
        >{{publishState === 1?'待审核':'审核已通过'}}</span>
      </footer>
    </template>
    <template v-else>
      <div style="padding:160px 0 0 250px">
        <img src="../../assets/img/signUp/no_data.png" alt />
      </div>
    </template>
    <div
      v-if="!hideMask"
      style="width:100%;height:100vh;position:fixed;background:#fff;top:106px;z-index:999999;left:290px;"
    ></div>
  </div>
</template>
<script>
import {
  addSign,
  updateSign,
  getSignDetailBySchool,
  getSignListBySchool
} from "@/api/sign-up-match";
import { getMatchList } from "@/api/sports-management";
import { getCoachList, getAthleteList } from "@/api/athletes.js";
import registerData from "@/assets/json/register.json";
import { table, message } from "@/common/js/mixins";
import { getSession } from "@/utils/storage.js";
import { rule } from "@/utils/utils";
export default {
  mixins: [table, message],
  // 报名表填写
  data() {
    return {
      publishState: 0,
      matchList: [],
      hideMask: false,
      isShowBtn: true,
      coachList: [],
      currentProject: {},
      athleteList: [],
      query: {
        id: "",
        raceName: "",
        matchId: "",
        leaderName: "",
        leaderPhone: "",
        leaderEmail: "",
        headCoachId: "",
        headCoachName: "",
        headCoachPhone: "",
        headCoachEmail: "",
        schoolName: JSON.parse(getSession("userInfo")).schoolName,
        groupId: "",
        coachIds: [],
        coachNames: "",
        workerNames: "",
        stayMan: "",
        stayWoman: ""
      },
      titles: [
        "name",
        "smallBallGroup",
        "smallBallSingles1",
        "smallBallSingles0",
        "smallBallDoubles1",
        "smallBallDoubles0",
        "smallBallMixed"
      ],
      editable: [],
      otherCoachList: [],
      loadingData: {
        submitLoading: false,
        saveLoading: false
      },
      rules: {
        raceName: [
          {
            required: true,
            message: "赛事名称不能为空",
            trigger: "blur"
          }
        ],
        leaderName: [
          {
            required: true,
            message: "领队姓名不能为空",
            trigger: "change"
          }
        ],
        leaderPhone: [
          { required: true, validator: rule.phone, trigger: "blur" }
        ],
        leaderEmail: [
          {
            validator: rule.email,
            trigger: "blur"
          }
        ],
        headCoachEmail: [
          {
            validator: rule.email,
            trigger: "blur"
          }
        ],
        headCoachId: [
          {
            required: true,
            message: "主教练不能为空",
            trigger: "change"
          }
        ],
        groupId: [
          {
            required: true,
            message: "组别不能为空",
            trigger: "change"
          }
        ],
        coachIds: [
          {
            required: true,
            message: "教练员不能为空",
            trigger: "change"
          }
        ],
        workerNames: [
          {
            required: true,
            message: "工作人员姓名不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    signGroup() {
      return registerData.registGroup;
    },
    // 状态为0或者2 表示草稿、驳回或未发布，此时可以修改，其他状态禁用
    isUpdate() {
      return this.publishState === 0 || this.publishState === 2 ? false : true;
    }
  },
  methods: {
    // 表格提交时判断是否有选择项目
    isSelectProject(index) {
      let bool = null;
      if (this.tableData[index].genderText === "男") {
        bool =
          this.tableData[index].smallBallGroup !== "下拉选择" ||
          this.tableData[index].smallBallSingles1 !== "下拉选择" ||
          this.tableData[index].smallBallDoubles1 !== "下拉选择" ||
          this.tableData[index].smallBallMixed !== "下拉选择";
      } else {
        bool =
          this.tableData[index].smallBallGroup !== "下拉选择" ||
          this.tableData[index].smallBallSingles0 !== "下拉选择" ||
          this.tableData[index].smallBallDoubles0 !== "下拉选择" ||
          this.tableData[index].smallBallMixed !== "下拉选择";
      }
      return bool;
    },
    // 男单女单任意一项选择后，将另一边禁止选用，男双女双逻辑相同
    selectSingles(value, index, key) {
      if (value !== "" && value !== "下拉选择") {
        if (key == "smallBallSingles1") {
          Object.assign(this.tableData[index], {
            smallBallSingles0: "-",
            isSingles: key
          });
        } else if (key == "smallBallSingles0") {
          Object.assign(this.tableData[index], {
            smallBallSingles1: "-",
            isSingles: key
          });
        } else if (key == "smallBallDoubles1") {
          Object.assign(this.tableData[index], {
            smallBallDoubles0: "-",
            isDoubles: key
          });
        } else {
          Object.assign(this.tableData[index], {
            smallBallDoubles1: "-",
            isDoubles: key
          });
        }
      } else {
        if (key === "smallBallSingles0" || key === "smallBallSingles1") {
          Object.assign(this.tableData[index], {
            smallBallSingles1: "下拉选择",
            smallBallSingles0: "下拉选择",
            isSingles: ""
          });
        } else {
          Object.assign(this.tableData[index], {
            smallBallDoubles1: "下拉选择",
            smallBallDoubles0: "下拉选择",
            isDoubles: ""
          });
        }
      }
    },
    // 获取赛事列表
    getMatch() {
      getMatchList({
        project: 6,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.matchList = res.list;
          this.isShowBtn = res.list.length === 0 ? false : true;
          this.hideMask = true;
          if (this.$route.query.id) this.selectMatch(this.$route.query.id);
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowBtn = false;
          }
          this.hideMask = true;
        });
    },
    // 生成表格
    makeTable(count = this.currentProject.count) {
      this.tableData = [];
      this.editable = [];
      for (let i = 0; i < count; i++) {
        this.tableData.push({
          name: "选择组别获取运动员数据",
          genderText: "",
          registerNumber: "",
          athleteId: "",
          studentNumber: "",
          startSchoolDateText: "",
          phone: "",
          smallBallGroup: "下拉选择",
          smallBallSingles1: "下拉选择",
          smallBallSingles0: "下拉选择",
          smallBallDoubles1: "下拉选择",
          smallBallDoubles0: "下拉选择",
          smallBallMixed: "下拉选择",
          isSingles: "",
          isDoubles: ""
        });
        let obj = {};
        this.titles.filter(temp => {
          obj[temp] = false;
        });
        this.editable.push(obj);
      }
    },
    // 选择赛事
    selectMatch(value) {
      Object.assign(this.query, this.$options.data().query);
      this.athleteList = [];
      this.$refs.form.resetFields();
      let data = {};
      this.matchList.filter(item => {
        if (item.id === value) data = item;
      });
      this.currentProject = data;

      Object.assign(this.query, {
        matchId: data.id,
        raceName: value
      });

      this.getSignDetail(value);
    },
    // 保存/提交
    submits(type) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let data = this.formatData();
          if (!data) return;

          if (!this.query.id) {
            this.loadingData.submitLoading = true;
            addSign({
              ...this.query,
              ...data,
              state: type === "submit" ? 1 : 0
            })
              .then(res => {
                this.loadingData.submitLoading = false;

                this.openSuccess(
                  type === "submit" ? "恭喜你，报名成功！" : "保存成功！"
                );

                this.$router.push({
                  path: "/pingpangball/pingpangball-registration-form-view",
                  query: {
                    id: this.query.raceName
                  }
                });
              })
              .catch(err => {
                this.loadingData.submitLoading = false;
              });
          } else {
            if (type === "submit") this.loadingData.submitLoading = true;
            else this.loadingData.saveLoading = true;
            updateSign({
              ...this.query,
              ...data,
              state: type === "submit" ? 1 : 0
            })
              .then(res => {
                if (type === "submit") this.loadingData.submitLoading = false;
                else this.loadingData.saveLoading = false;

                this.openSuccess(
                  type === "submit" ? "恭喜你，报名成功！" : "保存成功！"
                );

                this.$router.push({
                  path: "/pingpangball/pingpangball-registration-form-view",
                  query: {
                    id: this.query.raceName
                  }
                });
              })
              .catch(err => {
                if (type === "submit") this.loadingData.submitLoading = false;
                else this.loadingData.saveLoading = false;
              });
          }
        }
      });
    },
    // 清空重置
    clearData() {
      Object.assign(this.query, {
        leaderName: "",
        leaderPhone: "",
        leaderEmail: "",
        headCoachId: "",
        headCoachName: "",
        headCoachPhone: "",
        headCoachEmail: "",
        groupId: "",
        coachIds: [],
        coachNames: "",
        workerNames: "",
        stayMan: "",
        stayWoman: ""
      });
      this.tableData.filter((item, index) => {
        for (let temp in item) {
          if (temp === "name") {
            this.$set(this.tableData[index], temp, "选择组别获取运动员数据");
          } else if (temp === "remarks") {
            this.$set(this.tableData[index], temp, "非必填项");
          } else if (
            temp === "smallBallDoubles0" ||
            temp === "smallBallDoubles1" ||
            temp === "smallBallGroup" ||
            temp === "smallBallMixed" ||
            temp === "smallBallSingles0" ||
            temp === "smallBallSingles1"
          ) {
            this.$set(this.tableData[index], temp, "下拉选择");
          } else {
            this.$set(this.tableData[index], temp, "");
          }
        }
      });
      this.editable.filter((item, index) => {
        for (let temp in item) {
          this.$set(this.editable[index], temp, false);
        }
      });
      this.athleteList = [];
      this.$refs.form.resetFields();
      window.scrollTo(0, 0);
    },
    // 保存参数格式化
    formatData() {
      // 格式化参数
      let { headCoachId, coachIds } = this.query;
      let headCoachName = "";
      let coachNames = [];
      let athleteJson = [];
      let flag = false;
      let data = "";
      this.coachList.filter(item => {
        if (item.id === headCoachId) {
          headCoachName = item.name;
        }
      });
      coachIds.filter(item => {
        this.otherCoachList.filter(temp => {
          if (item === temp.id) {
            coachNames.push(temp.name);
          }
        });
      });
      this.tableData.filter((item, index) => {
        if (
          item.name !== "输入/下拉选择" &&
          item.name !== "选择组别获取运动员数据"
        ) {
          flag = true;
          if (!this.isSelectProject(index)) {
            data = "请至少选择一个项目";
          }
          athleteJson.push({
            athleteId: item.athleteId,
            projectJson: {
              smallBallGroup:
                item.smallBallGroup == "下拉选择" ? "" : item.smallBallGroup,
              smallBallSingles1:
                item.smallBallSingles1 == "下拉选择" ||
                item.smallBallSingles1 == "-"
                  ? ""
                  : item.smallBallSingles1,
              smallBallSingles0:
                item.smallBallSingles0 == "下拉选择" ||
                item.smallBallSingles0 == "-"
                  ? ""
                  : item.smallBallSingles0,
              smallBallDoubles1:
                item.smallBallDoubles1 == "下拉选择" ||
                item.smallBallDoubles1 == "-"
                  ? ""
                  : item.smallBallDoubles1,
              smallBallDoubles0:
                item.smallBallDoubles0 == "下拉选择" ||
                item.smallBallDoubles0 == "-"
                  ? ""
                  : item.smallBallDoubles0,
              smallBallMixed:
                item.smallBallMixed == "下拉选择" ? "" : item.smallBallMixed
            }
          });
        }
      });
      if (!flag) return this.openWarn("请添加运动员后进行操作!");
      if (data) return this.openWarn(data);
      return {
        headCoachName,
        coachIds: coachIds.join(","),
        coachNames: coachNames.join(","),
        athleteJson: JSON.stringify(athleteJson)
      };
    },
    // 输入框监听键盘事件
    handleKeyUp(e, index, key, className) {
      if (e.key === "ArrowRight") {
        this.arrowRight(index, key, className);
      } else if (e.key === "ArrowLeft") {
        this.arrowLeft(index, key, className);
      } else if (e.key === "ArrowUp") {
        this.arrowTop(index, key, className);
      } else if (e.key === "ArrowDown") {
        this.arrowDown(index, key, className);
      } else if (e.key === "Tab") {
        this.arrowTab(index, key, className);
      }
    },
    // 输入框tab监听
    arrowTab(index, key, className) {
      let num = this.titles.indexOf(key);
      let moveRow = 0;
      let moveName = "";

      if (index === this.tableData.length - 1 && num === this.titles.length - 1)
        return;
      else {
        if (num === this.titles.length - 1) {
          moveRow = index + 1;
          moveName = this.titles[1];
        } else {
          moveRow = index;
          moveName = this.titles[num + 1];
        }
      }

      this.changeNum(moveRow, moveName, className);
    },
    // 输入框监听上箭头事件
    arrowTop(index, key, className) {
      let moveRow = 0;
      // 到第一排时，return 反之，则到上一排的第一个输入位置
      if (index === 0) return;
      else moveRow = index - 1;

      this.changeNum(moveRow, key, className);
    },
    // 输入框监听下箭头事件
    arrowDown(index, key, className) {
      let moveRow = 0;
      // 到第一排时，return 反之，则到上一排的第一个输入位置
      if (index === this.tableData.length - 1) return;
      else moveRow = index + 1;

      this.changeNum(moveRow, key, className);
    },
    // 输入框监听左箭头事件
    arrowLeft(index, key, className) {
      let num = this.titles.indexOf(key);
      let moveRow = 0;
      let moveName = "";
      // 到第一项时，则到上一排的第一个输入位置
      if (num === 1) {
        if (index === 0) return;
        moveRow = index - 1;
        moveName = this.titles[this.titles.length - 1];
      } else {
        moveRow = index;
        moveName = this.titles[num - 1];
      }

      this.changeNum(moveRow, moveName, className);
    },
    // 输入框监听右箭头事件
    arrowRight(index, key, className) {
      let num = this.titles.indexOf(key);
      let moveRow = 0;
      let moveName = "";
      // 到最后一项时，则到下一排的第一个输入位置
      if (num === this.titles.length - 1) {
        if (index === this.tableData.length - 1) return;
        moveRow = index + 1;
        moveName = this.titles[1];
      } else {
        moveRow = index;
        moveName = this.titles[num + 1];
      }
      this.changeNum(moveRow, moveName, className);
    },
    // 选择运动员
    selectAthlete(value, num, col, details = false) {
      if (value) {
        this.athleteList.filter((item, index) => {
          this.$set(this.athleteList[index], "disabled", false);
        });
        let arr = [];
        if (!details) this.$set(this.tableData[num], "athleteId", "");
        this.tableData.filter((item, i) => {
          for (let j = 0; j < this.athleteList.length; j++) {
            if (
              item.name === this.athleteList[j].id ||
              item.athleteId === this.athleteList[j].id
            ) {
              this.$set(this.athleteList[j], "disabled", true);
              this.$set(this.athleteList[j], "numbers", i);
              arr.push(this.athleteList[j]);
              break;
            }
          }
        });
        arr.filter((item, i) => {
          for (let t in item) {
            if (this.tableData[item.numbers].hasOwnProperty(t)) {
              this.$set(this.tableData[item.numbers], t, item[t]);
            }
            this.$set(this.tableData[item.numbers], "athleteId", item.id);
          }
        });
        if (this.tableData[num].genderText === "女" && !details) {
          Object.assign(this.tableData[num], {
            isSingles: "smallBallSingles0",
            isDoubles: "smallBallDoubles0",
            smallBallSingles1: "-",
            smallBallSingles0: "下拉选择",
            smallBallDoubles1: "-",
            smallBallDoubles0: "下拉选择"
          });
        } else if (this.tableData[num].genderText === "男" && !details) {
          Object.assign(this.tableData[num], {
            isSingles: "smallBallSingles1",
            isDoubles: "smallBallDoubles1",
            smallBallSingles1: "下拉选择",
            smallBallSingles0: "-",
            smallBallDoubles1: "下拉选择",
            smallBallDoubles0: "-"
          });
        }
      } else {
        this.athleteList.filter((item, index) => {
          if (item.id === this.tableData[num].athleteId) {
            this.$set(this.athleteList[index], "disabled", false);
          }
        });
        this.$set(this.tableData[num], "athleteId", "");
        for (let item in this.tableData[num]) {
          if (item === "name")
            this.$set(this.tableData[num], item, "输入/下拉选择");
          else if (item === "remarks")
            this.$set(this.tableData[num], item, "非必填项");
          else if (
            item === "smallBallDoubles0" ||
            item === "smallBallDoubles1" ||
            item === "smallBallGroup" ||
            item === "smallBallMixed" ||
            item === "smallBallSingles0" ||
            item === "smallBallSingles1"
          ) {
            this.$set(this.tableData[num], item, "下拉选择");
          } else this.$set(this.tableData[num], item, "");
        }
      }

      setTimeout(() => {
        this.editable[num][col] = false;
      }, 200);
    },
    // 表格输入框离开焦点
    handleBlur(e, index, col) {
      setTimeout(() => {
        switch (col) {
          case "smallBallGroup":
          case "smallBallSingles1":
          case "smallBallSingles0":
          case "smallBallDoubles1":
          case "smallBallDoubles0":
          case "smallBallMixed": {
            if (!this.tableData[index][col]) {
              this.$set(this.tableData[index], col, "下拉选择");
            }
          }
        }
        this.editable[index][col] = false;
      }, 200);
    },
    // 表格点击
    changeNum(index, row, className) {
      // if(!this.query.groupId) this.openWarn('请先选择组别');
      this.editable.filter(item => {
        for (let temp in item) item[temp] = false;
      });
      this.editable[index][row] = true;
      if (
        this.tableData[index][row] === "输入" ||
        this.tableData[index][row] === "非必填项" ||
        this.tableData[index][row] === "下拉选择"
      )
        this.$set(this.tableData[index], row, "");
      //让input自动获取焦点
      this.$nextTick(() => {
        var editInputList = document.getElementsByClassName(className);
        editInputList[0].children[0].children[0].focus();
        // if (row === "name") editInputList[0].children[0].children[0].focus();
        // else editInputList[0].children[0].focus();
      });
    },
    // 选择组别，并获取运动员列表
    selectGroup(value) {
      this.getAthleteLists();
    },
    // 获取教练员列表
    getCoachLists() {
      getCoachList({})
        .then(res => {
          this.coachList = [...res];
          res.filter(item => {
            item.disabled = false;
          });
          this.otherCoachList = [...res];
        })
        .catch(err => {});
    },
    // 选择主教练员后获取对应电话填入
    selectCoach(value) {
      this.$set(this.query, "coachIds", []);

      this.otherCoachList.filter(temp => {
        temp.disabled = false;
      });
      if (value) {
        this.coachList.filter(item => {
          if (item.id === value) {
            this.query.headCoachPhone = item.phone;
          }
        });
        this.otherCoachList.filter(temp => {
          if (value === temp.id) {
            temp.disabled = true;
          }
        });
        let _field = this.$refs["form"].fields;
        _field.map(i => {
          if (i.prop === "coachIds") {
            //通过prop属性值相同来判断是哪个输入框，比如：要移除prop为'user'
            i.resetField();
            return false;
          }
        });
      }
    },
    // 获取当前赛事运动员列表
    getAthleteLists() {
      getAthleteList({
        pageNo: 1,
        pageSize: 999,
        groupId: this.query.groupId,
        isPass: 1,
        effective: 1,
        isOld:0,
        gender:
          this.currentProject.gender === -1 ? "" : this.currentProject.gender
      })
        .then(res => {
          if (res.list.length === 0) {
            this.openWarn("当前组别无运动员数据");
          }
          res.list.filter(item => {
            item.disabled = false;
          });
          this.tableData.filter((item, index) => {
            for (let temp in item) {
              if (temp === "name") {
                this.$set(this.tableData[index], temp, "输入/下拉选择");
              } else if (temp === "remarks") {
                this.$set(this.tableData[index], temp, "非必填项");
              } else if (
                temp === "smallBallDoubles0" ||
                temp === "smallBallDoubles1" ||
                temp === "smallBallGroup" ||
                temp === "smallBallMixed" ||
                temp === "smallBallSingles0" ||
                temp === "smallBallSingles1"
              ) {
                this.$set(this.tableData[index], temp, "下拉选择");
              } else {
                this.$set(this.tableData[index], temp, "");
              }
            }
          });
          this.editable.filter((item, index) => {
            for (let temp in item) {
              this.$set(this.editable[index], temp, false);
            }
          });

          this.athleteList = [...res.list];
        })
        .catch(err => {});
    },
    // 获取当前赛事运动员列表（草稿）
    getAthleteListByDraft() {
      return new Promise((resolve, reject) => {
        getAthleteList({
          pageNo: 1,
          pageSize: 999,
          isPass: 1,
          effective: 1,
        isOld:0,
          groupId: this.query.groupId,
          gender:
            this.currentProject.gender === -1 ? "" : this.currentProject.gender
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取详情，如果有数据，则表示已经提交或草稿数据，如果审核已通过，则修改表格显示数量
    getSignDetail(id) {
      getSignDetailBySchool({ matchId: id })
        .then(res => {
          if (res) {
            this.publishState = res.state;
            Object.assign(this.query, {
              workerNames: res.workerNames,
              groupId: res.groupId,
              leaderName: res.leaderName,
              leaderPhone: res.leaderPhone,
              leaderEmail: res.leaderEmail,
              headCoachEmail: res.headCoachEmail,
              headCoachId: res.headCoachId,
              headCoachPhone: res.headCoachPhone,
              headCoachName: res.headCoachName,
              coachIds: !res.coachIds ? [] : res.coachIds.split(","),
              stayMan: res.stayMan,
              stayWoman: res.stayWoman,
              id: res.id
            });
            this.getAthleteListByDraft()
              .then(data => {
                data.list.filter(item => {
                  item.disabled = false;
                });

                this.athleteList = [...data.list];
                if (res.state === 3) this.makeTable(res.athleteList.length);
                else this.makeTable();
                for (let i = 0; i < this.tableData.length; i++) {
                  this.$set(this.tableData[i], "name", "输入/下拉选择");
                }
                res.athleteList.filter((item, index) => {
                  Object.assign(this.tableData[index], {
                    name: item.athleteName,
                    remarks: !item.remarks ? "非必填项" : item.remarks,
                    athleteId: item.athleteId,
                    smallBallGroup: !item.projectJson.smallBallGroup
                      ? "下拉选择"
                      : item.projectJson.smallBallGroup,
                    smallBallSingles1: this.isValidateProject(
                      res.state,
                      item.projectJson,
                      "smallBallSingles1",
                      item.genderText,
                      index
                    ),
                    smallBallSingles0: this.isValidateProject(
                      res.state,
                      item.projectJson,
                      "smallBallSingles0",
                      item.genderText,
                      index
                    ),
                    smallBallDoubles1: this.isValidateProject(
                      res.state,
                      item.projectJson,
                      "smallBallDoubles1",
                      item.genderText,
                      index
                    ),
                    smallBallDoubles0: this.isValidateProject(
                      res.state,
                      item.projectJson,
                      "smallBallDoubles0",
                      item.genderText,
                      index
                    ),
                    smallBallMixed: !item.projectJson.smallBallMixed
                      ? "下拉选择"
                      : item.projectJson.smallBallMixed
                  });
                  this.selectAthlete(item.athleteId, index, "name", true);
                });
              })
              .catch(err => {});
          } else {
            this.publishState = 0;
            this.makeTable();
          }
        })
        .catch(err => {});
    },
    //
    isValidateProject(state, value, key, gender, index) {
      switch (gender) {
        case "男": {
          Object.assign(this.tableData[index], {
            smallBallSingles0: "-",
            isSingles: "smallBallSingles1",
            isDoubles: "smallBallDoubles1",
            smallBallDoubles0: "-"
          });
          let str =
            key === "smallBallSingles1"
              ? value.smallBallSingles1
              : key === "smallBallSingles0"
              ? "-"
              : key === "smallBallDoubles1"
              ? value.smallBallDoubles1
              : "-";
          if (state === 3) {
            return !str ? str : str === "-" ? "" : str;
          } else if (state === 1) {
            return !str ? str : str === "-" ? "-" : str;
          }
          return !str ? "下拉选择" : str;
        }
        case "女": {
          Object.assign(this.tableData[index], {
            smallBallSingles1: "-",
            isSingles: "smallBallSingles0",
            isDoubles: "smallBallDoubles0",
            smallBallDoubles1: "-"
          });
          let str =
            key === "smallBallSingles1"
              ? "-"
              : key === "smallBallSingles0"
              ? value.smallBallSingles0
              : key === "smallBallDoubles1"
              ? "-"
              : value.smallBallDoubles0;
          if (state === 3) {
            return !str ? str : str === "-" ? "" : str;
          } else if (state === 1) {
            return !str ? str : str === "-" ? "-" : str;
          }
          return !str ? "下拉选择" : str;
        }
      }
    }
  },
  mounted() {
    this.getMatch();
    this.getCoachLists();
    window.addEventListener("keydown", e => {
      if (e.keyCode == "9") e.preventDefault();
    });
  },
  destroyed() {
    window.removeEventListener("keydown", event => {
      event.preventDefault();
    });
  }
};
</script>
<style lang="less" scoped>
.application_form_box {
  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: rgba(192, 196, 204, 0.1);
  }
  .application_form {
    > li {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      > p {
        display: flex;
        align-items: center;
        margin-right: 120px;
        .basics {
          width: 70px;
          margin-right: 10px;
          text-align: right;
        }
      }
    }
  }
  .table_select_box {
    /deep/ .el-input__inner {
      line-height: 30px;
      height: 30px;
    }
    /deep/ .el-input__icon {
      line-height: 30px;
    }
  }
  footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    .btns {
      margin: 0;
      color: #1e63b0;
      border: 1px solid #1e63b0;
    }
  }
}
</style>